import { apiClient } from './client.js';
import type {
  AvailableSlot,
  BlockSlotInput,
  CreateRecurringSlotBlockInput,
  RecurringSlotBlock,
  UnblockSlotInput,
} from '@atomfit/shared';
import type { AxiosResponse } from 'axios';

export const slotsApi = {
  list: (
    gymId: string,
    date: string,
    signal?: AbortSignal,
  ): Promise<AxiosResponse<{ data: AvailableSlot[] }>> =>
    apiClient.get<{ data: AvailableSlot[] }>(
      '/slots',
      signal ? { params: { gymId, date }, signal } : { params: { gymId, date } },
    ),

  block: (data: BlockSlotInput) =>
    apiClient.post('/owner/slots/block', data),

  unblock: (data: UnblockSlotInput) =>
    apiClient.post('/owner/slots/unblock', data),

  recurringBlocks: (gymId: string) =>
    apiClient.get<{ data: RecurringSlotBlock[] }>('/owner/slots/recurring-blocks', {
      params: { gymId },
    }),

  createRecurringBlock: (data: CreateRecurringSlotBlockInput) =>
    apiClient.post<RecurringSlotBlock>('/owner/slots/recurring-blocks', data),

  deleteRecurringBlock: (ruleId: string) =>
    apiClient.delete(`/owner/slots/recurring-blocks/${ruleId}`),
};
